import { render } from "./VoyageContent.vue?vue&type=template&id=71867ad5&scoped=true"
import script from "./VoyageContent.vue?vue&type=script&lang=js"
export * from "./VoyageContent.vue?vue&type=script&lang=js"

import "./VoyageContent.vue?vue&type=style&index=0&id=71867ad5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71867ad5"]])

export default __exports__